module.exports = __webpack_public_path__ + "img/sld_dcdb_b1.a221cb29.svg";